import React, {Component} from 'react';
import '../../local_node_modules/react-select/dist/react-select.css';
import Table from "../../components/Table/Table";
import {deepCopyObject, hasUserRight, showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import NavBarKS from "../../components/NavBarKS";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import moment from "moment";
import TextOverFlowTooltip from "../../components/TextOverFlowTooltip";
import RequestMessageModal from "./RequestMessageModal";
import ExcelExporter from "../../components/ExcelExporter";
import * as headerContent from "../../constants/exportcontent";
import {ACCESS_TOKEN, EntegratorConf, VirtualHost} from "../../constants";
import Alert from "react-s-alert";
import {EntegratorIdentifiers, UserRightsEnum} from "../../helper/enums";


class RequestMessageList extends Component {
	constructor(props) {
		super(props);
		this.state = {content: [],
			total: 0,
			loading: false,
			serviceList: [],
			distributorList:[],
			page: 0,
			size: 10,
			url: null,
			searchQuery: undefined,
            recordId: null,
			modal:false,
			users:[],
			showingLoginModal:false,
			disabledLoginBtn: false,
			distributorsList:[]
		};
		this.fetchData = this.fetchData.bind(this);
		this.handleSearch 	= this.handleSearch.bind(this);
		this.getList   = this.getList.bind(this);
		this.getDistributors   = this.getDistributors.bind(this);
		this.impersonate = this.impersonate.bind(this);
		this.findDistributor = this.findDistributor.bind(this);
		this.getDistributorsAll = this.getDistributorsAll.bind(this);
	}

	componentWillMount() {
		this.getList();
		this.getDistributors();
		this.getDistributorsAll();
		this.findDistributor();

	}

	getList(){
		this.setState({modal: this.props.modal});
		let self = this;
		let params = {
			url:"/requestmessage/getList",
			method: "post"
		};
		self.setState({loading: true});
		request(params)
			.then(function (response) {
				let data = response.data;
				let services = data.services;
				services.push({ublCode:"Diğer",ublName:"DIGER"});
				services.push({ublCode:"Tümü",ublName:null});
				let serviceList = services.map(service => ({
					value: service.ublName,
					label: service.ublCode
				}));
				self.setState({serviceList});
			}).catch(function (error) {
			showAxiosError(error);
		}).then(function () {
			self.setState({loading: false});
		});

	}
	getDistributors(){
		this.setState({modal: this.props.modal});
		let self = this;
		let distributorList=[];
		let params = {
			url:"/customer/getDistributors",
			method: "get"
		};
		self.setState({loading: true});
		request(params)
			.then(function (response) {
				let data = response.data;
				let distributors=data;
				distributorList.push({label:"Tümü",value:null});
				for(let i=0;i<distributors.length;i++) {
					distributorList.push({
						value: distributors[i][0],
						label:(distributors[i][1] !== data[0][1] && distributors[i][5] !== data[0][1]) ?
							(distributors[i][1].length === 10 ? distributors[i][2] : (distributors[i][3].trimEnd() + ' ' + distributors[i][4])) + (' (' + (distributors[i][5].length === 10 ? distributors[i][6] : (distributors[i][7].trimEnd() + ' ' + distributors[i][8])) + ')') :
							(distributors[i][1].length === 10 ? distributors[i][2] : (distributors[i][3].trimEnd() + ' ' + distributors[i][4])),
					});
				}
				self.setState({distributorList,loading: false});
			}).catch(function (error) {
			showAxiosError(error);
		}).then(function () {
			self.setState({loading: false});
		});

	}

	findDistributor(row){
		if(this.state.distributorsList){
			let distributors = deepCopyObject(this.state.distributorsList);
			return distributors.map(distributor => {
				console.log(row.customer.parentCustomerId)
				if(distributor[0] === row.customer.parentCustomerId){
					return (distributor[1] !== this.state.distributorsList[0][1] && distributor[5] !== this.state.distributorsList[0][1]) ?
						(distributor[1].length === 10 ? distributor[2] : (distributor[3].trimEnd() + ' ' + distributor[4])) + (' (' + (distributor[5].length === 10 ? distributor[6] : (distributor[7].trimEnd() + ' ' + distributor[8])) + ')') :
						(distributor[1].length === 10 ? distributor[2] : (distributor[3].trimEnd() + ' ' + distributor[4]));
				}
			})
		}else{
			return "";
		}
	}

	async getDistributorsAll() {
		let self = this;
		let params = {
			url: "/customer/getDistributors",
			method: "get"
		};
		await request(params)
			.then(response => {
				self.setState({distributorsList: response.data});
			}).catch(error => {
			});
	}

	fetchData(accessor, direction, page, size) {
		let self = this;
		let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '&sort=createdAt,desc';
		let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
		let params = {
			url: '/requestmessage/getRequestMessageList?page=' + page + '&size=' + size + sortStr + searchQuery,
			method: "post"
		};
		self.setState({loading: true, manual: self.manual === true ? false: self.manual});
		self.props.reload(true);
		request(params)
		.then(function (response) {
			self.setState({
				page: page,
				size: size,
				total: response.data.totalElements,
				content: response.data.content,
				loading: false,
				searching: false
			});
			self.props.reload(false);
		}).catch(function (error) {
			self.setState({loading: false,searching: false});
			self.props.reload(false);
			showAxiosError(error);
		});
	}

	impersonate(recordId) {
		if (recordId) {
			this.setState({disabledLoginBtn: true});
			let self = this;
			let params = {
				url: '/user/impersonate',
				method: "post",
				data: {
					recordId: recordId
				}
			};
			request(params)
				.then(function (response) {
					console.log(response)
					let data = response.data;
					localStorage.setItem(ACCESS_TOKEN, data.accessToken);
					self.props.onLogin();
					self.props.onImpersonate(true);
					self.setState({disabledLoginBtn: false});
				}).catch(function (error) {
				showAxiosError(error);
				self.setState({disabledLoginBtn: false});
			});
		} else {
			Alert.error("Kullanıcı seçimi yapmalısınız.", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 1500
			});
		}
	}

	handleSearch(searchQuery) {
		this.setState({searchQuery, searching: true}, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size))
	}

	render() {
		const distributorList=this.state.distributorList;

		const source = VirtualHost.conf.resourcePrefix;

		const defaultHeaders = headerContent.requestMessageContent;

		const columns = [
			{
				Header: "Talep Numarası",
				accessor:"recordId",
			},
			{
				Header: "VKN/TCKN",
				accessor:"vknTckn",
				Cell: row => (<div><TextOverFlowTooltip text={row.customer ? row.customer.vknTckn :""} maxLength={23}></TextOverFlowTooltip></div>)
			},
			{
				Header: "Müşteri Adı",
				accessor:"customerName",
				Cell: row => (<div><TextOverFlowTooltip text={row.customer ? row.customer.customerName :""} maxLength={23}></TextOverFlowTooltip></div>)
			},
			{
				Header: "Bayi",
				accessor: "parentCustomerId",
				Cell: row => (
					<div>{this.findDistributor(row)}</div>
				)
			},
			{
				Header: "Konu Tipi",
				accessor:"subjectType"
			},
			{
				Header: "Konu",
				accessor:"subject",
				Cell: row => (<div><TextOverFlowTooltip text={row.subject || ""} maxLength={23}></TextOverFlowTooltip></div>)
			},
			{
				Header: "Talep Durumu",
				accessor:"statusMessage",
				Cell: row => (<p className={row.statusMessage === "Cevap verildi" ? "text-success":"text-warning"}>{row.statusMessage || ""}</p>)
			},
			{
				Header: "Talep Tarihi",
				accessor:"createdAt",
				Cell: row => (<div>{(row.createdAt ? moment(row.createdAt).format("DD-MM-YYYY HH:mm:ss") : "-")}</div>)
			},
			{
				Header: "Cevap Tarihi",
				accessor:"answerAt",
				Cell: row => (<div>{(row.answerAt ? moment(row.answerAt).format("DD-MM-YYYY HH:mm:ss") : "-")}</div>)
			},
			{
				Header: "Atanan Kişi",
				accessor:"user",
				Cell: row => (<div>{(row.user.firstName !== null ? row.user.firstName + " " + row.user.lastName : "-")}</div>)
			},
			{
				Header: "İşlemler",
				accessor:"",
				sortable:false,
				Cell: row => (<div>
					<button type="button"
							 data-toggle="tooltip"
							 data-placement="bottom"
							 onClick={(e) => this.setState({requestMessageModal: true, recordId: row.recordId})}
							 title="Göster"
							 style={{background: 'orange'}} rel="tooltip"
							 className="Btn btn-icon">
						<i className="BtnIcon fa fa-eye"/>
					</button>

					{(this.props.allowPrivateAccess || (this.props.currentUser.roleId &&
							(this.props.currentUser.roleId === 5 || this.props.currentUser.roleId === 3 || this.props.currentUser.roleId === 4))) &&
						!((EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier || EntegratorIdentifiers.SMART === EntegratorConf.identifier || EntegratorIdentifiers.MBT === EntegratorConf.identifier) &&
							(this.props.impersonateUserRoleId === 3 || this.props.impersonateUserRoleId === 4)) &&
						hasUserRight(UserRightsEnum.entegratorSettings.accessCustomerPortal, this.props.currentUser) &&
					<button type="button"
							data-toggle="tooltip"
							data-placement="bottom"
							onClick={() => this.impersonate(row.userId)}
							title="Kullanıcı Portalına Git"
							style={{background: 'rgb(52, 216, 103)'}} rel="tooltip"
							className="Btn btn-icon">
						<i className="BtnIcon fa fa-desktop"/>
					</button>
					}
                </div>)
			}
		];

		const fields = [
			{
				label: "Talep Numarası",
				accessor: "recordId",
				type: "numericText",
				operator: "=",
			},
			{
				label: "Müşteri Adı",
				accessor: "customer_customerName",
				type: "text",
				operator: "=",
			},
			{
				label: "VKN/TCKN",
				accessor: "customer_vknTckn",
				type: "numericText",
				operator: "=",
			},
			{
				label: "Bayi",
				accessor: "parentCustomerId",
				type: "select",
				operator: "=",
				selectData: this.state.distributors
			},
			{
				label: "Konu",
				accessor: "subject",
				type: "text",
				operator: "=",
			},
			{
				label: "Talep Durumu",
				accessor: "statusMessage",
				type: "select",
				operator: "=",
				selectData: [
					{label:"Talep Alındı",value:"Talep Alındı"},
					{label:"Cevap verildi",value:"Cevap verildi"},
					{label:"Tümü",value:null}
				]
			},
			{
				label: "Konu Tipi",
				accessor: "subjectType",
				type: "select",
				operator: "=",
				selectData: this.state.serviceList
			},
			{
				label: "Oluşturulma Tarihi (Başlangıç)",
				accessor: "min_createAt",
				type: "datetime",
				operator: ">=",
			},
			{
				label: "Oluşturulma Tarihi (Bitiş)",
				accessor: "max_createAt",
				type: "datetime",
				operator: "<=",
			},
			{
				label: "Cevap Tarihi (Başlangıç)",
				accessor: "min_answerAt",
				type: "datetime",
				operator: ">=",
			},
			{
				label: "Cevap Tarihi (Bitiş)",
				accessor: "max_answerAt",
				type: "datetime",
				operator: "<=",
			}
		];

		if (this.props.isEntegrator)
		{
			fields.push({
					label: "Bayi",
					accessor: "customer_parentCustomerId",
					type: "select",
					operator: "=",
					selectData: distributorList,
				})
		}

		return (
			<div className="row baseBackground">
				<NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth} name="requestMessageList">
					{ !((EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier ||
						EntegratorIdentifiers.SMART === EntegratorConf.identifier ||
						EntegratorIdentifiers.MBT === EntegratorConf.identifier) && this.props.currentUser && ((this.props.currentUser.roleId === 3 || this.props.currentUser.roleId === 4) ||
						(this.props.impersonateUserRoleId === 3 || this.props.impersonateUserRoleId === 4))) && <ExcelExporter position="leftSide"
									url={this.state.searchQuery ? '/requestmessage/exportXls?sort=createdAt,desc&' + this.state.searchQuery : '/requestmessage/exportXls?sort=createdAt,desc'}
									sheetName='Istek_Talep_Raporu'
									title="Excel'e Aktar"
									defaultHeaders={defaultHeaders}
									icon='excel'
									type='creditReport'
									completeFetch={true}
									impersonateUserRoleId={this.props.impersonateUserRoleId}/>}
				</NavBarKS>

				<div className="col-sm-12 satirBasi">
					<div className="card-header">
						<h4 className="card-title">İstek/Talep Raporu</h4>
					</div>
					<div className="card-body">
						<DetailedSearch fields={fields}
										loading={this.state.searching}
										onSearch={this.handleSearch}/>
					</div>
					<div className="card-body">
						<Table columns={columns}
							   loading={this.state.loading}
							   loadingText="Kayıtlar getiriliyor..."
							   content={this.state.content}
							   total={this.state.total}
							   page={this.state.page}
							   manual={this.state.manual}
							   size={this.state.size}
							   options={["5", "10", "20", "50", "100"]}
							   fetchData={this.fetchData}
						/>
					</div>
				</div>

                {this.state.requestMessageModal &&
                    <RequestMessageModal modal={this.state.requestMessageModal} adminUser={this.props.currentUser.entegrator} recordId={this.state.recordId} listener={(e) => this.setState({requestMessageModal: false,manual:true})}/>
                }
			</div>
		);
	}
}

export default RequestMessageList;